/* InLei® Studiofinder — sections/inlei-studiofinder.liquid

   Die Studio-Karten stehen fertig im HTML. Dieses Skript ergänzt nur:
   Stecknadeln auf der SVG-Karte, Suche nach PLZ/Ort, Filter nach Angebot,
   Entfernung und Sortierung, „In meiner Nähe“ (Standort bleibt im Browser).

   Die PLZ-Tabellen werden erst geladen, wenn jemand eine PLZ sucht:
   fünfstellig → Deutschland (assets/inlei-plz-de.js, ~70 KB),
   vierstellig → Österreich/Schweiz (assets/inlei-plz-at-ch.js, ~45 KB).
   Vierstellige PLZ gibt es in beiden Ländern; „A-1010“ oder „CH-8001“
   legt das Land fest, sonst gilt das Land des Shop-Besuchs, und ein
   Knopf bietet das andere Land an. */
(() => {
  const SVG_NS = 'http://www.w3.org/2000/svg';
  // Gleiche Projektion wie in snippets/inlei-deutschlandkarte.liquid
  const K = Math.cos((51.2 * Math.PI) / 180);
  const punkt = (lat, lon) => [(lon - 5.8) * K * 100, (55.1 - lat) * 100];

  // Je Land: Tabelle, Stellen der PLZ, Breite, ab der die Tabelle zählt
  const LAENDER = {
    DE: { tabelle: 'INLEI_PLZ_DE', stellen: 5, ab: 47, name: 'Deutschland', in: 'in Deutschland', kurz: 'D' },
    AT: { tabelle: 'INLEI_PLZ_AT', stellen: 4, ab: 45, name: 'Österreich', in: 'in Österreich', kurz: 'A' },
    CH: { tabelle: 'INLEI_PLZ_CH', stellen: 4, ab: 45, name: 'Schweiz', in: 'in der Schweiz', kurz: 'CH' }
  };

  function ausTabelle(land, plz) {
    const l = LAENDER[land];
    const s = window[l.tabelle];
    const n = l.stellen + 4;
    if (!s || s.length % n !== 0) return null;
    let lo = 0;
    let hi = s.length / n - 1;
    while (lo <= hi) {
      const m = (lo + hi) >> 1;
      const k = s.substr(m * n, l.stellen);
      if (k < plz) lo = m + 1;
      else if (k > plz) hi = m - 1;
      else {
        return [
          parseInt(s.substr(m * n + l.stellen, 2), 36) / 100 + l.ab,
          parseInt(s.substr(m * n + l.stellen + 2, 2), 36) / 100 + 5
        ];
      }
    }
    return null;
  }

  // „50667“, „D-50667“, „1010“, „A-1010“, „AT 1010“, „CH-8001“ → { land, plz };
  // bei vier Ziffern ohne Vorsatz ist das Land noch offen (null)
  function alsPlz(roh) {
    const t = String(roh || '').trim().toUpperCase().replace(/\s+/g, ' ');
    let m = t.match(/^(?:DE?[ -]?)?(\d{5})$/);
    if (m) return { land: 'DE', plz: m[1] };
    m = t.match(/^AT?[ -]?(\d{4})$/);
    if (m) return { land: 'AT', plz: m[1] };
    m = t.match(/^CH[ -]?(\d{4})$/);
    if (m) return { land: 'CH', plz: m[1] };
    m = t.match(/^(\d{4})$/);
    if (m) return { land: null, plz: m[1] };
    return null;
  }

  const laeuft = {};
  function tabelleLaden(quelle, name) {
    if (window[name] || !quelle) return Promise.resolve();
    if (laeuft[quelle]) return laeuft[quelle];
    laeuft[quelle] = new Promise((fertig) => {
      const el = document.createElement('script');
      el.src = quelle;
      el.onload = () => fertig();
      el.onerror = () => fertig();
      document.head.appendChild(el);
    });
    return laeuft[quelle];
  }

  function entfernung(a, b) {
    const rad = (g) => (g * Math.PI) / 180;
    const dLat = rad(b[0] - a[0]);
    const dLon = rad(b[1] - a[1]);
    const h =
      Math.sin(dLat / 2) ** 2 + Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(dLon / 2) ** 2;
    return 2 * 6371 * Math.asin(Math.min(1, Math.sqrt(h)));
  }

  const gerundet = (km) => (km < 10 ? Math.max(1, Math.round(km)) : Math.round(km / 5) * 5) + ' km';
  const normal = (t) =>
    String(t || '')
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .trim();

  function init(root) {
    if (!root || root.dataset.studiofinderBereit) return;
    root.dataset.studiofinderBereit = '1';

    const liste = root.querySelector('[data-studios-liste]');
    const nadeln = root.querySelector('[data-studios-nadeln]');
    const suchort = root.querySelector('[data-studios-suchort]');
    const eingabe = root.querySelector('[data-studios-eingabe]');
    const status = root.querySelector('[data-studios-status]');
    const leer = root.querySelector('[data-studios-leer]');
    const naehe = root.querySelector('[data-studios-naehe]');
    const chips = [...root.querySelectorAll('[data-studios-filter]')];
    const wahl = root.querySelector('[data-studios-landwahl]');
    // Land des Shop-Besuchs (Shopify-Markt) — entscheidet bei vierstelligen PLZ
    const besuchLand = root.dataset.land === 'CH' ? 'CH' : root.dataset.land === 'AT' ? 'AT' : null;
    const laden = (land) =>
      land === 'DE'
        ? tabelleLaden(root.dataset.plzQuelle, 'INLEI_PLZ_DE')
        : tabelleLaden(root.dataset.plzQuelleAtCh, 'INLEI_PLZ_AT');

    const studios = [...root.querySelectorAll('[data-studio]')].map((el, i) => {
      const lat = parseFloat(el.dataset.lat);
      const lon = parseFloat(el.dataset.lon);
      return {
        el,
        i,
        lat,
        lon,
        ok: !isNaN(lat) && !isNaN(lon),
        text: normal(el.dataset.name + ' ' + el.dataset.ort + ' ' + el.dataset.plz),
        plz: el.dataset.plz || '',
        leistungen: (el.dataset.leistungen || '').split(' '),
        km: null,
        nadel: null
      };
    });

    // ---------- Stecknadeln ----------
    studios.forEach((st) => {
      if (!st.ok) return;
      const [x, y] = punkt(st.lat, st.lon);
      const g = document.createElementNS(SVG_NS, 'g');
      const hauptsitz = 'hauptsitz' in st.el.dataset;
      g.setAttribute('class', 'inlei-studios__nadel' + (st.leistungen.includes('trainer') ? ' inlei-studios__nadel--trainer' : '') + (hauptsitz ? ' inlei-studios__nadel--hauptsitz' : ''));
      g.setAttribute('tabindex', '0');
      g.setAttribute('role', 'button');
      g.setAttribute('aria-label', st.el.dataset.name + ', ' + st.el.dataset.ort);
      const c = document.createElementNS(SVG_NS, 'circle');
      c.setAttribute('cx', x.toFixed(1));
      c.setAttribute('cy', y.toFixed(1));
      c.setAttribute('r', hauptsitz ? '16' : '7');
      g.appendChild(c);
      // Hauptsitz zuletzt zeichnen, damit er über benachbarten Punkten liegt
      if (hauptsitz) nadeln.appendChild(g);
      else nadeln.insertBefore(g, nadeln.querySelector('.inlei-studios__nadel--hauptsitz'));
      st.nadel = g;

      const waehlen = () => {
        aktiv(st);
        st.el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      };
      g.addEventListener('click', waehlen);
      g.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          waehlen();
          const link = st.el.querySelector('a');
          if (link) link.focus({ preventScroll: true });
        }
      });
      st.el.addEventListener('mouseenter', () => aktiv(st));
      st.el.addEventListener('focusin', () => aktiv(st));
    });

    function aktiv(st) {
      studios.forEach((s) => {
        const an = s === st;
        s.el.classList.toggle('is-aktiv', an);
        if (s.nadel) s.nadel.classList.toggle('is-aktiv', an);
      });
      // aktive Nadel nach vorn, damit sie nicht von Nachbarn verdeckt wird
      if (st && st.nadel) nadeln.appendChild(st.nadel);
    }

    // Am Handy steht die Karte zwischen Suche und Liste — nach einer Suche
    // direkt zum ersten Treffer, am Desktop ist die Liste ohnehin daneben.
    function zuErgebnissen() {
      if (!window.matchMedia('(max-width: 989px)').matches) return;
      setTimeout(() => liste.scrollIntoView({ behavior: 'smooth', block: 'start' }), 400);
    }

    // ---------- Filter, Suche, Sortierung ----------
    let ort = null; // [lat, lon] der Suche oder des Standorts
    let ortName = '';

    function anwenden() {
      const filter = chips.filter((c) => c.getAttribute('aria-pressed') === 'true').map((c) => c.dataset.studiosFilter);
      const roh = eingabe.value.trim();
      const textsuche = !ort && roh && !alsPlz(roh) ? normal(roh) : '';

      studios.forEach((st) => {
        st.km = ort && st.ok ? entfernung(ort, [st.lat, st.lon]) : null;
        let sichtbar = filter.every((f) => st.leistungen.includes(f));
        if (sichtbar && textsuche) {
          sichtbar = /^\d+$/.test(textsuche) ? st.plz.startsWith(textsuche) : st.text.includes(textsuche);
        }
        st.el.hidden = !sichtbar;
        if (st.nadel) st.nadel.classList.toggle('is-aus', !sichtbar);
        const km = st.el.querySelector('[data-studio-entfernung]');
        km.hidden = st.km === null;
        km.textContent = st.km === null ? '' : gerundet(st.km);
      });

      const sortiert = [...studios].sort((a, b) => (ort ? (a.km ?? 1e9) - (b.km ?? 1e9) : a.i - b.i));
      sortiert.forEach((st) => liste.appendChild(st.el));

      const zu = studios.filter((s) => !s.el.hidden);
      leer.hidden = zu.length > 0;
      if (!zu.length) status.textContent = 'Kein Studio gefunden';
      else if (ort) {
        const naechstes = sortiert.find((s) => !s.el.hidden && s.km !== null);
        status.textContent =
          zu.length + (zu.length === 1 ? ' Studio' : ' Studios') +
          ', sortiert nach Entfernung ' + ortName +
          (naechstes ? ' · nächstes in ' + gerundet(naechstes.km) : '');
      } else {
        status.textContent = zu.length + (zu.length === 1 ? ' Studio' : ' Studios') + (textsuche || filter.length ? ' gefunden' : ' ' + (root.dataset.gebiet || 'in Deutschland'));
      }

      suchort.textContent = '';
      if (ort) {
        const [x, y] = punkt(ort[0], ort[1]);
        const c = document.createElementNS(SVG_NS, 'circle');
        c.setAttribute('cx', x.toFixed(1));
        c.setAttribute('cy', y.toFixed(1));
        c.setAttribute('r', '16');
        suchort.appendChild(c);
      }
    }

    chips.forEach((chip) =>
      chip.addEventListener('click', () => {
        chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        anwenden();
      })
    );

    // Vierstellige PLZ, die es in Österreich und der Schweiz gibt: anderes Land anbieten
    function landwahl(plz, andere) {
      if (!wahl) return;
      wahl.textContent = '';
      wahl.hidden = !andere;
      if (!andere) return;
      const knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'inlei-studios__landwahl-knopf';
      knopf.textContent = plz + ' ' + LAENDER[andere].in + ' gemeint?';
      knopf.addEventListener('click', () => {
        eingabe.value = LAENDER[andere].kurz + '-' + plz;
        suchen();
      });
      wahl.appendChild(knopf);
    }

    function suchen() {
      const p = alsPlz(eingabe.value);
      landwahl();
      if (p) {
        status.textContent = 'Suche …';
        laden(p.land || 'AT').then(() => {
          let land = p.land;
          let andere = null;
          if (!land) {
            const inAt = !!ausTabelle('AT', p.plz);
            const inCh = !!ausTabelle('CH', p.plz);
            land = inAt && inCh ? besuchLand || 'AT' : inCh ? 'CH' : 'AT';
            if (inAt && inCh) andere = land === 'AT' ? 'CH' : 'AT';
          }
          ort = ausTabelle(land, p.plz);
          ortName = ort ? 'ab ' + p.plz + ' (' + LAENDER[land].name + ')' : '';
          anwenden();
          if (!ort) {
            status.textContent = 'Diese PLZ kennen wir nicht — bitte prüfen.';
            return;
          }
          landwahl(p.plz, andere);
        });
        return;
      }
      ort = null;
      anwenden();
    }

    root.querySelector('[data-studios-suche]').addEventListener('submit', (e) => {
      e.preventDefault();
      eingabe.blur();
      suchen();
      zuErgebnissen();
    });

    let warte;
    eingabe.addEventListener('input', () => {
      clearTimeout(warte);
      warte = setTimeout(() => {
        // Tippt jemand weiter, gilt der alte Suchort nicht mehr
        if (!alsPlz(eingabe.value)) ort = null;
        suchen();
      }, 250);
    });

    if (naehe && 'geolocation' in navigator) {
      naehe.hidden = false;
      naehe.addEventListener('click', () => {
        status.textContent = 'Standort wird ermittelt …';
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            ort = [pos.coords.latitude, pos.coords.longitude];
            ortName = 'ab deinem Standort';
            eingabe.value = '';
            anwenden();
            zuErgebnissen();
          },
          () => {
            status.textContent = 'Standort nicht verfügbar — gib einfach deine PLZ ein.';
          },
          { timeout: 10000, maximumAge: 600000 }
        );
      });
    }

    // Ortsverzeichnis: Klick filtert direkt, ohne die Seite neu zu laden
    root.querySelectorAll('[data-studios-ort]').forEach((a) =>
      a.addEventListener('click', (e) => {
        e.preventDefault();
        eingabe.value = a.dataset.studiosOrt;
        ort = null;
        suchen();
        history.replaceState(null, '', a.getAttribute('href'));
        root.querySelector('.inlei-studios__raster').scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
    );

    // Direktlinks wie /pages/studiofinder?ort=Köln oder ?plz=50667
    const param = new URLSearchParams(location.search);
    const vorgabe = param.get('plz') || param.get('ort');
    if (vorgabe) {
      eingabe.value = vorgabe;
      suchen();
    }

    // Tabelle vorladen, sobald jemand ins Feld tippt — dann ist die Suche sofort da
    eingabe.addEventListener('focus', () => laden(besuchLand || 'DE'), { once: true });
  }

  const alle = () => document.querySelectorAll('[data-studiofinder]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-studiofinder]')));
})();
